import { gql } from '@apollo/client';

// --- Queries ---

export const GET_USER_AUTH = gql`
  query GetUserAuth($teamId: String) {
    getUserAuth(teamId: $teamId) {
      _id
      username
      emails {
        address
      }
      profile {
        firstName
        lastName
        phoneNumber
        phoneCountryFlag
        title
        adress1
        adress2
        city
        country
        state
        zipcode
        language
      }
      multiFactorConfig {
        totp
        phone
      }
      needSyncFromFirebase
    }
  }
`;

export const GET_BACKUP_CODES_REMAINING = gql`
  query GetBackupCodesRemainingCount {
    getBackupCodesRemainingCount
  }
`;

export const DOWNLOAD_BACKUP_CODES = gql`
  query DownloadBackupCodes {
    downloadBackupCodes
  }
`;

// --- Mutations ---

export const UPDATE_USER_AUTH = gql`
  mutation UpdateUserAuth($updateData: UpdateUserProfileInput!, $teamId: String) {
    updateUserAuth(updateData: $updateData, teamId: $teamId) {
      _id
      profile {
        firstName
        lastName
        phoneNumber
        phoneCountryFlag
        title
        adress1
        adress2
        city
        country
        state
        zipcode
        language
      }
    }
  }
`;

export const UPDATE_USER_SETTINGS_AUTH = gql`
  mutation UpdateUserSettingsAuth($updateData: UpdateUserSettingsInput!, $teamId: String) {
    updateUserSettingsAuth(updateData: $updateData, teamId: $teamId) {
      _id
      dateFormat
      timeFormat
      numberFormat
      scaleTemperature
      windSpeedUnit
      defaultValueType
      isShowWelcomeTips
      assetIsDupClickMode
      isHideBannerPromotionForPaidUser
    }
  }
`;

// Generic user settings mutation — accepts any settings as JSON
// Used for wizardSettings.hideWelcomeEngage (not in typed UpdateUserSettingsInput)
export const UPDATE_USER_SETTINGS = gql`
  mutation UpdateUserSettings($payload: UpdateUserSettingInput!, $teamId: String) {
    updateUserSettings(payload: $payload, teamId: $teamId)
  }
`;

export const UPDATE_USER_MFA = gql`
  mutation UpdateUserMFA($payload: UpdateUserMFAInput!) {
    updateUserMFA(payload: $payload)
  }
`;

export const GENERATE_BACKUP_CODES = gql`
  mutation GenerateBackupCodes {
    generateBackupCodes
  }
`;

export const SET_VERIFICATION_EMAIL = gql`
  mutation SetVerificationEmail($sendEmail: Boolean!) {
    setVerificationEmail(sendEmail: $sendEmail)
  }
`;

export const SET_FIREBASE_EMAIL_VERIFIED = gql`
  mutation SetFirebaseEmailVerified($flag: Boolean!) {
    setFirebaseEmailVerified(flag: $flag)
  }
`;

export const SET_NEED_SYNC_FROM_FIREBASE = gql`
  mutation SetNeedSyncFromFirebase($uid: String!) {
    setNeedSyncFromFirebase(uid: $uid)
  }
`;

export const SYNC_MFA_FROM_FIREBASE = gql`
  mutation SyncMfaFromFirebase($uid: String!) {
    syncMfaFromFirebase(uid: $uid)
  }
`;

export const VALIDATE_RECOVERY_CODE_AND_SIGN_IN = gql`
  mutation ValidateRecoveryCodeAndSignIn($payload: ValidateRecoveryCodeInput!) {
    validateRecoveryCodeAndSignIn(payload: $payload)
  }
`;

/** Result type for GET_CUSTOM_LOGIN_TOKEN query */
export interface GetCustomLoginTokenResult {
  getCustomLoginToken: string | null;
}

/** Variables type for GET_CUSTOM_LOGIN_TOKEN query */
export interface GetCustomLoginTokenVariables {
  token: string;
}

export const GET_CUSTOM_LOGIN_TOKEN = gql`
  query GetCustomLoginToken($token: String!) {
    getCustomLoginToken(token: $token)
  }
`;

// --- Feature discovery (per-user tab highlight) ---

/** Stamp the first time this user saw a highlighted feature tab. Write-once server-side. */
export const MARK_FEATURE_DISCOVERED = gql`
  mutation MarkFeatureDiscovered($key: String!) {
    markFeatureDiscovered(key: $key)
  }
`;

export interface MarkFeatureDiscoveredResponse {
  markFeatureDiscovered: boolean;
}

/** Increment this user's click count for a highlighted feature tab. */
export const RECORD_FEATURE_CLICK = gql`
  mutation RecordFeatureClick($key: String!) {
    recordFeatureClick(key: $key)
  }
`;

export interface RecordFeatureClickResponse {
  recordFeatureClick: boolean;
}
